<template>
  <div class="skeleton certification-tile">
    <div class="certification-tile__wrapper">
      <div class="certification-tile__tile skeleton__animate">
        <p class="skeleton__animate--white certification-tile__badge"></p>
        <p class="skeleton__animate--white certification-tile__title"></p>
        <p class="skeleton__animate--white certification-tile__bottom"></p>
        <p class="skeleton__animate--white certification-tile__bottom"></p>
      </div>
      <div class="certification-tile__tile skeleton__animate">
        <p class="skeleton__animate--white certification-tile__badge"></p>
        <p class="skeleton__animate--white certification-tile__title"></p>
        <p class="skeleton__animate--white certification-tile__bottom"></p>
        <p class="skeleton__animate--white certification-tile__bottom"></p>
      </div>
      <div class="certification-tile__tile skeleton__animate">
        <p class="skeleton__animate--white certification-tile__badge"></p>
        <p class="skeleton__animate--white certification-tile__title"></p>
        <p class="skeleton__animate--white certification-tile__bottom"></p>
        <p class="skeleton__animate--white certification-tile__bottom"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CertificationTileSkel',
}
</script>

<style lang="scss" scoped>
.certification-tile {
  margin: 0 0 80px 0;
  width: 100%;
  &__wrapper {
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
  }
  &__tile {
    @include mobile {
      width: calc(50% - 10px);
    }
    @include tablet {
      width: calc(33% - 10px);
    }
    height: 250px;
    background-color: var(--gray);
    margin: 5px;
    position: relative;
    height: 480px;
    left: 0px;
    top: 0px;
    border-radius: 10px;
    padding: 30px;
  }
  &__badge {
    margin: 30px auto;
    width: 160px;
    height: 200px;
  }
  &__title {
    margin: 30px 0 20px;
    width: 220px;
    height: 25px;
  }
  &__bottom {
    height: 15px;
  }
}
</style>
